
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SmsTemplateInterface } from '@/services/SMS/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddSmsTemplate from '@/services/SMS/forms/AddSmsTemplate';
@Component
export default class EditSmsTemplateDialog extends Vue {
  @Prop() private readonly template!: SmsTemplateInterface
  @Prop() private readonly onDelete!: CallableFunction

  private form: WPXFormValue<AddSmsTemplate> = new WPXFormValue(AddSmsTemplate)

  public name:string = ''
  public senderName:string = ''
  public message:string = ''
  public id:number;

  private visible: boolean = true

  public async mounted(): Promise<void> {
    this.name = this.template.name
    this.senderName = this.template.senderName
    this.message = this.template.predefinedMessage
    this.id = this.template.id
  }

  private destroyComponent(): void {
    this.$emit('close')
  }

  public updateComponent(name:string, senderName:string, message:string,id:number) : void {
    this.$emit('update',id,{name,senderName,message})
  }
}
